import { gql } from '@apollo/client';

export const CREATE_DEPOSIT = gql`
  mutation CreateDeposit($deposit: CreateDepositInput!) {
    deposit: createDeposit(createDepositInput: $deposit) {
      id
    }
  }
`;
